const authOrderLocalStorageKey = 'fromOrderParams';
const authOrderPathnameKey = 'fromOrderPathname';

export const saveFromOrderAuthParams = () => {
  // shredding previous save, 'cause it's Enter re-entry
  localStorage.removeItem(authOrderLocalStorageKey);

  const params = new URLSearchParams(location.search);

  const fromParam = params.get('from');

  if (fromParam && fromParam.startsWith('order')) {
    params.delete('from');
    localStorage.setItem(authOrderLocalStorageKey, params.toString());
    localStorage.setItem(authOrderPathnameKey, fromParam.substring(5));
  }
};

export const interceptAuthFromOrder = () => {
  const fromOrderParams = localStorage.getItem(authOrderLocalStorageKey);
  const orderPagePath = localStorage.getItem(authOrderPathnameKey) || '/guest-upgrade/';

  if (fromOrderParams) {
    localStorage.removeItem(authOrderLocalStorageKey);
    window.location.href = `${process.env.ORDER_PAGE_URL}${orderPagePath}?${fromOrderParams}`;

    return true;
  }
};
